/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import { hot } from 'react-hot-loader/root'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/rail.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import Cover from '../cover'
import Episode from '../episode'
import EpisodeAudio from '../episodeaudio'
import SideBar from '../sidebar'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Waypoint } from 'react-waypoint'
import { Grid } from 'semantic-ui-react'

// TODO Set the correct article ID here
const ARTICLE_ID = '23248793'

export class AppComponent extends React.Component<Props, State> {
  constructor(props) {
    super(props)

    this.state = {
      isMobile: window.innerWidth < 770,
      isDockOpen: false
    }

    this.toggleSideBar = this.toggleSideBar.bind(this)
  }

  toggleSideBar() {
    console.log('toggle dock')
    this.setState({ isDockOpen: !this.state.isDockOpen })
  }

  render() {
    return (
      <div className='index inverted'>
        <Masthead inverted articleId={ARTICLE_ID} />
        <ThemeSwitch />

        <header className='ui vertical fitted segment first'>
          <Cover
            title='Wahrheit, Wein und Eisenring'
            subtitle='Das ehrlichste Gesprächsformat der Schweiz'
          />
        </header>

        <div className='content'>
          <div className='ui container'>
            <div className='ta secondary caption'>
              {' '}
              Sie kennt keine Tabus – ihre Gäste auch nicht: Yvonne Eisenring.
              Foto: Urs Jaudas
            </div>
          </div>

          <div
            className='ui vertical fitted segment'
            style={{ paddingBottom: '0.5em' }}
          >
            <div className='ui text container'>
              <p className='ta lead'>
                Verrat, Lohn, Tod und Selbstbefriedigung – in unserem neuen
                Podcast sprechen Schweizer Prominente in einer Bar ehrlich und
                offen über Tabuthemen.
              </p>
              <p className='ta author' style={{ paddingTop: '2em' }}>
                Yvonne Eisenring
              </p>
              <p>
                Wie viel verdienst du? Worauf bist du neidisch? Was sind deine
                sexuellen Fantasien? Hast du Angst vor dem Tod? Bist du schon
                mal fremdgegangen? Wofür schämst du dich?
              </p>
              <p>
                Solche Fragen stellt man nicht. Diskretion ist eine Tugend
                unseres Landes, Zurückhaltung erwünscht. Besonders in
                öffentlichen Gesprächen und mit prominenten Personen. Man will
                ja nicht unverschämt sein, will niemanden brüskieren. Aber: Auf
                Smalltalk habe ich keine Lust mehr. Weder im Privaten noch im
                Beruf. Nur über «sichere» Themen wie Wetter, Urlaub und Erfolge
                will ich nicht reden, ganz egal, wie beeindruckend und bekannt
                mein Gegenüber ist. Was mich interessiert, sind Themen, die uns
                alle betreffen und beschäftigen. Themen, die mitunter tabu sind.
              </p>
              <p>
                Es heisst, es gebe heute weniger Tabus, aber das bezweifle ich.
                Das Wort Sex ist zwar omnipräsent, aber über das, was im
                Schlafzimmer wirklich läuft – oder eben nicht –, spricht man
                dann doch nicht. Schräge Anekdoten erzählt man voller Stolz,
                aber wofür man sich auch noch Jahre später schämt, gibt man
                ungern zu. Und der Tod wird so stiefmütterlich behandelt, als
                gehöre er zum Leben nicht dazu.
              </p>
              <p>
                In meinem neuen Gesprächsformat «Wahrheit, Wein und Eisenring»
                gibt es keine Tabus. In der Olé Olé Bar an der Langstrasse in
                Zürich treffe ich prominente Persönlichkeiten zu einem radikal
                ehrlichen Gespräch. Abends um 20 Uhr, ganz hinten am Tresen.
                Meine Gäste wissen, worauf sie sich einlassen – und gehen
                dennoch, oder gerade deshalb, auf meine Einladung ein. Es dürfen
                Fragen verweigert – oder zurückgestellt werden. Meine einzige
                Bedingung ist, dass die Gäste ehrlich sind. Und das waren sie
                bisher alle. Mehr, als ich je erwartet hätte. Ich erfuhr, was
                ihre Süchte, ihre Geheimnisse und ihre Ängste sind. Sie
                erzählten, was sie bereuen und wofür sie sich schämen. Sie waren
                aufrichtig und direkt – und ich mitunter sprachlos.
              </p>
              <div>
                <div className='story-hint'>
                  <div className='hint-container'>
                    <img
                      src={require('./images/cards.jpg')}
                      className='ui fluid image'
                      style={{ paddingBottom: '1em' }}
                    />
                    <h5>Die Spielregeln</h5>
                    Auf dem Bartresen liegt ein Stapel Spielkarten. Darauf
                    stehen Tabuthemen wie Drogen, Sex, Vermögen, Einsamkeit,
                    Verlust oder Scham. Während des Gesprächs zieht der Gast
                    verdeckt eine Karte nach der anderen. So wird bestimmt, über
                    welche Themen gesprochen wird. Abbrechen ist jederzeit
                    erlaubt, lügen nicht. Jede Frage darf der Gast auch an die
                    Gastgeberin zurückgeben: Ehrlichkeit verlangt Ehrlichkeit.
                    Das Gespräch endet nach ca. 45 Minuten – oder dann, wenn der
                    Gesprächspartner abbricht.
                    <div style={{ marginTop: '1em' }}>
                      <a onClick={this.toggleSideBar}>
                        <img src={require('./images/cards.svg')} />{' '}
                        <span
                          style={{
                            verticalAlign: 'top',
                            top: '3px',
                            position: 'relative',
                            paddingLeft: '0.2em'
                          }}
                        >
                          Übersicht aller Karten
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <aside
              className='ui right rail computer or lower hidden'
              style={{ top: '10%', left: '70%' }}
            >
              <div className='story-hint'>
                <div
                  className='hint-container'
                  style={{ fontSize: '0.9em', lineHeight: '1.3em' }}
                >
                  <img
                    src={require('./images/yvonne-eisenring.jpg')}
                    className='ui fluid image'
                    style={{ paddingBottom: '1em' }}
                  />
                  Yvonne Eisenring ist Autorin, Journalistin und Moderatorin.
                  Ihre Essays, Kolumnen und Fernsehreportagen wurden mehrfach
                  ausgezeichnet. 2018 hat sie das internationale Reiseprojekt
                  «Yuujou» mitbegründet. Sie ist Gastdozentin an der Hochschule
                  Luzern, studiert Philosophie und lebt in Zürich, New York und
                  Paris.
                </div>
              </div>
            </aside>
          </div>

          <SideBar
            isDockOpen={this.state.isDockOpen}
            toggleSideBar={this.toggleSideBar}
          />

          <div className='ui container'>
            <EpisodeAudio
              photo={require('./images/landmann.jpg')}
              episodeNr={7}
              name='Valentin Landmann'
              tags='über <span>Fetisch, Krankheit, Fremdgehen, Unsterblichkeit</span> und <span>Feinde</span>'
              audioFile='https://cdn.simplecast.com/audio/915f1a/915f1ada-8e9e-4ef5-b39d-6b1f25b19ac4/06ab79c5-1f80-4346-bd76-83c06fe4abc1/valentin-landmann-podcast-final_tc.mp3'
              simpleCastID='06ab79c5-1f80-4346-bd76-83c06fe4abc1'
              quote='«Mehr als Unfug habe ich an einer Sadomaso-Party nie getrieben»'
              about='Je düsterer der Fall, desto grösser ist die Wahrscheinlichkeit, dass Valentin Landmann (69) öffentlich dazu Stellung nimmt. Der bekannte Schweizer Anwalt erzählt von seinem aktuellen Mandanten – einem Schweizer Banker, der Frauen über Nacht in einen Tresor sperrte – und seinen Erlebnissen in der Sadomaso-Szene. Und er gesteht, was er bis heute bereut.
                  '
              spotifyURL='https://open.spotify.com/episode/4rgGjmXILHDU000Cwk8r36'
              appleURL='https://podcasts.apple.com/ch/podcast/valentin-landmann-%C3%BCber-fetisch-krankheit-fremdgehen/id1491136173?i=1000462715624'
            />

            <Waypoint
              onEnter={event => {
                if (
                  event.previousPosition === Waypoint.below &&
                  event.currentPosition === Waypoint.inside
                ) {
                  window.dataLayer = window.dataLayer || []
                  window.dataLayer.push({
                    event: 'Interactions',
                    event_action: 'vertical-scroll',
                    event_label: '50ContentRead'
                  })
                }
              }}
            />
          </div>

          <div className='ui container archive'>
            <hr />
            <h4>Frühere Episoden</h4>
            <Grid columns={this.state.isMobile ? 1 : 2}>
              {/*
              <Grid.Column>
                <EpisodeAudio
                  isArchived
                  photo={require('./images/landmann.jpg')}
                  episodeNr={7}
                  name='Valentin Landmann'
                  tags='über <span>Fetisch, Krankheit, Fremdgehen, Unsterblichkeit</span> und <span>Feinde</span>'
                  audioFile='https://cdn.simplecast.com/audio/915f1a/915f1ada-8e9e-4ef5-b39d-6b1f25b19ac4/06ab79c5-1f80-4346-bd76-83c06fe4abc1/valentin-landmann-podcast-final_tc.mp3'
                  simpleCastID='06ab79c5-1f80-4346-bd76-83c06fe4abc1'
                  quote='«Mehr als Unfug habe ich an einer Sadomaso-Party nie getrieben»'
                  about='Je düsterer der Fall, desto grösser ist die Wahrscheinlichkeit, dass Valentin Landmann (69) öffentlich dazu Stellung nimmt. Der bekannte Schweizer Anwalt erzählt von seinem aktuellen Mandanten – einem Schweizer Banker, der Frauen über Nacht in einen Tresor sperrte – und seinen Erlebnissen in der Sadomaso-Szene. Und er gesteht, was er bis heute bereut.
                  '
                />
              </Grid.Column>
              */}
              <Grid.Column>
                <EpisodeAudio
                  isArchived
                  photo={require('./images/pesenti.jpg')}
                  episodeNr={6}
                  name='Sabrina Pesenti                  '
                  tags='über <span>Selbstbefriedigung, Alter, Schulden, Fremdgehen, Geheimnisse</span> und <span>Ekel</span>'
                  audioFile='https://cdn.simplecast.com/audio/915f1a/915f1ada-8e9e-4ef5-b39d-6b1f25b19ac4/1b2739df-ea9a-49c1-868e-28c00f95a9a0/sabrina-pesenti-podcast-final_tc.mp3'
                  simpleCastID='1b2739df-ea9a-49c1-868e-28c00f95a9a0'
                  quote='«Ich glaubte, Gott schaut mir bei der Selbstbefriedigung zu»'
                  about='Ihre blonde Mähne ist unübersehbar. Sabrina Pesenti ist PR-Managerin von L’Oreal Schweiz und ehemalige Bloggerin. Am Bartresen spricht sie über ihre aktuellen Beziehungsschwierigkeiten und erzählt, welche Schönheitsoperation sie einmal machen lassen würde. Zudem sagt sie, warum Selbstbefriedigung bei Stress und Frust hilft.'
                  spotifyURL='https://open.spotify.com/episode/4WgYg1GB5RYacQOB74IwT3'
                  appleURL='https://podcasts.apple.com/ch/podcast/sabrina-pesenti-%C3%BCber-selbstbefriedigung-alter-schulden/id1491136173?i=1000461997105'
                />
              </Grid.Column>

              <Grid.Column>
                <EpisodeAudio
                  isArchived
                  photo={require('./images/sterkoudis.jpg')}
                  episodeNr={5}
                  name='Seigi Sterkoudis'
                  tags='über <span>Exzess, Unsterblichkeit, Alter, Eifersucht, Scham</span> und <span>Reue</span>'
                  audioFile='https://cdn.simplecast.com/audio/915f1a/915f1ada-8e9e-4ef5-b39d-6b1f25b19ac4/84267ab6-ccfd-47ce-b5b4-bc1371f5c607/seigi-sterkoudis-podcast-final_tc.mp3'
                  simpleCastID='84267ab6-ccfd-47ce-b5b4-bc1371f5c607'
                  quote='«Ein Freund von mir starb vor meinen Augen»'
                  about='Seigi Sterkoudis’ (50) Gastfreundschaft ist legendär. Er führt das Kaufleuten in Zürich und das Pöstli in Davos mit viel Herzblut und ebenso viel Erfolg. Der gebürtige Grieche gesteht, wofür er zu viel Geld ausgibt und dass er weniger kiffen möchte. Während des Gespräches fliessen sogar die Tränen: Seigi Sterkoudis spricht über verstorbene Freunde und erzählt vom Tag, an dem er selber dem Tod entkommen ist.'
                  spotifyURL='https://open.spotify.com/episode/2ozWGzLyB9nY7rN8cemTT6'
                  appleURL='https://podcasts.apple.com/ch/podcast/seigi-sterkoudis-%C3%BCber-exzess-unsterblichkeit-alter/id1491136173?i=1000460752749'
                />
              </Grid.Column>

              <Grid.Column>
                <EpisodeAudio
                  isArchived
                  photo={require('./images/landolt.jpg')}
                  episodeNr={4}
                  name='Cindy Landolt'
                  tags='über <span>One-Night-Stands, Scham, Alter, Geheimnisse, Unsicherheit, Neid</span> und <span>Krankheit</span>'
                  audioFile='https://cdn.simplecast.com/audio/915f1a/915f1ada-8e9e-4ef5-b39d-6b1f25b19ac4/7962dd35-3a64-45a3-b0ae-0c3d4b6deeb9/cindy-landolt-podcast-final_tc.mp3'
                  simpleCastID='7962dd35-3a64-45a3-b0ae-0c3d4b6deeb9'
                  quote='«One-Night-Stands? Hatte ich noch nie»'
                  about='Über 600’000 Personen verfolgen das Leben von Cindy Landolt (34) auf Instagram. Die Fitnesstrainerin gehört damit zu den erfolgreichsten Social-Media-Stars der Schweiz. Im Gespräch an der Bar erzählt sie, dass sie keinen Kinderwunsch verspürt, warum sie ihre Brüste vergrössern liess und wie sie mit eindeutigen Angeboten von Männern umgeht.'
                  spotifyURL='https://open.spotify.com/episode/3SpGIV9GYuRwZxCKTIb06e'
                  appleURL='https://podcasts.apple.com/ch/podcast/cindy-landolt-%C3%BCber-one-night-stands-scham-alter-geheimnisse/id1491136173?i=1000460752748'
                />
              </Grid.Column>

              <Grid.Column>
                <EpisodeAudio
                  isArchived
                  photo={require('./images/giacobbo.jpg')}
                  episodeNr={3}
                  name='Viktor Giacobbo'
                  tags='über <span>Komplexe</span>, <span>Scham</span>, <span>Drogen</span>, <span>Neid</span>, <span>Ticks</span>, <span>Einsamkeit</span>, <span>Lügen</span> und <span>Geheimnisse</span>'
                  audioFile='https://cdn.simplecast.com/audio/915f1a/915f1ada-8e9e-4ef5-b39d-6b1f25b19ac4/fcc1c178-3670-4c7b-b129-91c4fcf4852d/viktor-nov-final-mixdown_tc.mp3'
                  simpleCastID='fcc1c178-3670-4c7b-b129-91c4fcf4852d'
                  quote='«Für manche Dinge schäme ich mich auch nach <nobr>20 Jahren»</nobr>'
                  about='Komiker, Autor und Moderator – Viktor Giacobbo x(67) gehört nicht zuletzt dank der satirischen Fernsehsendung «Giacobbo/Müller» zu den prominentesten Gesichtern des Landes. In «Wahrheit, Wein und Eisenring» erzählt er, warum er sieben Jahre lang eine Scheinehe führte, was ihn am Filmgeschäft stört und warum er sich beim Duschen an peinliche Momente erinnert.'
                  spotifyURL='https://open.spotify.com/episode/6fWVp2uMz3Ogzyt5JAanca'
                  appleURL='https://podcasts.apple.com/ch/podcast/viktor-giacobbo-%C3%BCber-komplexe-scham-drogen-neid-ticks/id1491136173?i=1000460096503'
                />
              </Grid.Column>

              <Grid.Column>
                <EpisodeAudio
                  isArchived
                  photo={require('./images/rosenwasser.jpg')}
                  episodeNr={2}
                  name='Anna Rosenwasser'
                  tags='über <span>sexuelle Fantasien, Angst, Fetisch, Einsamkeit, Versagen, Geheimnisse</span> und <span>Drogen</span>'
                  audioFile='https://cdn.simplecast.com/audio/915f1a/915f1ada-8e9e-4ef5-b39d-6b1f25b19ac4/69b495c3-3b04-46dc-b602-442c3061d6de/anna-rosenwasser-final-4_tc.mp3'
                  simpleCastID='69b495c3-3b04-46dc-b602-442c3061d6de'
                  quote='«Ich dachte lange, für Blowjobs müsse man sich hinknien»'
                  about='Sie ist die wohl bekannteste Bisexuelle der Schweiz. Anna Rosenwasser (29) ist Co-Geschäftsführerin der Lesbenorganisation Schweiz, Juso-Mitglied und freischaffende Journalistin. Bei einem Glas Rotwein sagt sie, wie sie mit ihrer Angststörung umgeht, wie Ritalin ihren Alltag beeinflusst und warum es wohl viel mehr bisexuelle Menschen gibt als angenommen.'
                  spotifyURL='https://open.spotify.com/episode/6cRdwHO3QyYxf2d5goXbC4'
                  appleURL='https://podcasts.apple.com/ch/podcast/anna-rosenwasser-%C3%BCber-sexuelle-fantasien-angst-fetisch/id1491136173?i=1000459280688'
                />
              </Grid.Column>

              <Grid.Column>
                <EpisodeAudio
                  isArchived
                  photo={require('./images/basman.jpg')}
                  episodeNr={1}
                  name='Joel Basman'
                  tags='über <span>Ticks, sexuelle Tabus, Lügen, Einsamkeit, Versagen, Sucht</span> und <span>Lohn</span>'
                  audioFile='https://cdn.simplecast.com/audio/915f1a/915f1ada-8e9e-4ef5-b39d-6b1f25b19ac4/6ae3f857-ec64-431f-9ca7-8c6c3d9b2796/joel-basman-podcast-final-1_tc.mp3'
                  simpleCastID='6ae3f857-ec64-431f-9ca7-8c6c3d9b2796'
                  quote='«In keinem einzigen meiner Filme siehst du meine Hände»'
                  about='Er feiert weltweit Filmerfolge: Der Schauspieler Joel Basman (29) war zuletzt mit «Der Büezer» im Kino, für seine Rolle als Motti in «Wolkenbruchs wunderliche Reise in die Arme einer Schickse» erhielt er dieses Jahr den Schweizer Filmpreis. Im Gespräch verrät er, warum er sich so für seine Hände schämt, was für ihn beim Sex absolut tabu ist und wann er einen Seitensprung verschweigen würde.'
                  spotifyURL='https://open.spotify.com/episode/7hMPdrZC5hwuzdVGumDJ0C'
                  appleURL='https://podcasts.apple.com/ch/podcast/joel-basman-%C3%BCber-ticks-sexuelle-tabus-l%C3%BCgen-einsamkeit/id1491136173?i=1000459280687'
                />
              </Grid.Column>
            </Grid>
          </div>

          {/*
          <div className='ui text container comingup archive'>
            <h4>Kommende Episoden</h4>
            <ul>
              <li>
                26. Dezember: <strong>Sabrina Pesenti</strong>
                <br />
                über Selbstbefriedigung, Alter, Schulden, Fremdgehen,
                Geheimnisse und Ekel
              </li>
              <li>
                2. Januar: <strong>Valentin Landmann</strong>
                <br />
                über Fetisch, Krankheit, Fremdgehen, Unsterblichkeit und Feinde
              </li>
            </ul>
          </div>
            */}
        </div>

        {/* TODO Add your credits in this component */}
        <Footer
          inverted
          articleId={ARTICLE_ID}
          questions={[
            'Wie unterhaltsam sind die Gespräche?',
            'Wie gefällt Ihnen das Podcast-Format?',
            'Wie gefällt Ihnen die Gestaltung?'
          ]}
          credits={[
            ['Idee, Interviews und Text', 'Yvonne Eisenring'],
            ['Projektleitung', 'Katharina Graf'],
            ['Programmierung', 'Mathias Lutz'],
            [
              'Produktion Podcasts',
              'Jan Derrer (Leitung), Marco Pietrocola, Anthony Ackermann und Sacha Schwarz'
            ],
            ['Fotos', 'Urs Jaudas und Marco Pietrocola']
          ]}
          topHalfClassName='dark-grey'
          bottomHalfClassName='black'
          hidePortfolioTeaser
        />
      </div>
    )
  }
}

export default hot('AppComponent')
